"use client";

import { NotificationMessage } from '@/models/notification';
import {
    DocumentSnapshot,
    collection,
    getDocs,
    limit,
    query,
    orderBy,
    addDoc,
    serverTimestamp,
} from "firebase/firestore";
import { db } from "@/helpers/firebase/firebase";
import { Collections } from "@/helpers/utils/collections";


const notificationMap = (doc: DocumentSnapshot): NotificationMessage => {
    const data = {
        ...doc.data(),
        id: doc.id,
        timestamp: doc.data()?.timestamp.toDate(),
    } as NotificationMessage;

    return data;
}

export async function getAllNotifications(): Promise<NotificationMessage[]> {

    // Get last 20 notifications
    const notificationSnapshot = await getDocs(query(
        collection(db, Collections.NOTIFICATIONS),
        orderBy('timestamp', 'desc'),
        limit(20)
    ));

    return notificationSnapshot.docs.map(notificationMap);

}

export async function addNotificationToDb(notification: Partial<NotificationMessage>) {
    const notificationMap = {
        ...notification,
        timestamp: serverTimestamp(),
    }

    delete notificationMap.isRead;
    delete notificationMap.id;
    return await addDoc(collection(db, Collections.NOTIFICATIONS), notificationMap);
}